export const TRANSLATIONS_EN = {
  heroText: 'Find your next destination',
  searchPlaces: 'Search places',
  home: 'Home',
  places: 'Places',
  contact: 'Contact',
  admin: 'Admin',
  login: 'Sign In',
  logout: 'Logout',
  mostPopular: 'Most popular',
  mostPopularText: 'Our most popular places',
  cabins: 'Cabins',
  apartments: 'Apartments',
  hotels: 'Hotels',
  viewPlaces: 'View places',
  allTypes: 'All types',
  order: 'Order',
  userReviews: 'User reviews',
  leaveReview: 'Leave a review',
  rating: 'Rating',
  name: 'Name',
  reviewText: 'Review',
  publish: 'Publish',
  showMore: 'Show more',
  showLess: 'Show less',
  urlCopied: 'URL copied to clipboard',
  fullName: 'Full Name',
  guests: 'Guests',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  close: 'Close',
  sendingOrder: 'Sending order...',
  sendOrder: 'Send order',
  nameHere: 'Name here',
  reviewTextHere: 'Review text here',
  message: 'Message',
  messageHere: 'Your message here',
  welcome: 'Welcome',
  orders: 'Orders',
  inbox: 'Inbox',
  view: 'View',
  createNewPlace: 'Create new place',
  totalOrder: 'Total orders',
  totalPlaces: 'Total places',
  ordered: 'Ordered',
  deleteItem: 'Are you sure you want to delete this item?',
  created: 'Created',
  messages: 'messages',
  from: 'From',
  sent: 'Sent',
  placeName: 'Place name',
  imageUrl: 'image URL',
  placeType: 'Place type',
  price: 'Price',
  description: 'Description',
  descriptionText: 'Description here',
  create: 'Create',
  creating: 'Creating...',
  chooseType: 'Choose a type',
  choosePrice: 'Choose a price',
  usernameOrEmail: 'Username or email',
  password: 'Password',
  signInNow: 'Sign in now',
  signingIn: 'Signing in...',
  wrongPassword: 'Invalid username or password',
  copyright: 'Copyright 2021 © Holidaze All rights Reserved.',
  norwegian: 'Norwegian (Norsk)',
  english: 'English (Engelsk)',
  noResult: 'No result...',
  searchOrder: 'Search orders (place, name and order ID)',
  pageNotFound: 'Page not found',
  orderError: 'Something went wrong...',
  confirmOrder: 'Order successfully sent',
  createPlaceError: 'Something went wrong when creating place...',
  confirmCreatePlace: 'Place successfully created',
  sendingError: 'Something went wrong when sending...',
  messageSent: 'Message successfully sent',
};
